import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetShippingAddressQuery } from "src/api/services/addressApi";
import WhiteCard from "src/shared/components/WhiteCard";

const ShippingCard = () => {
  const { data, isLoading } = useGetShippingAddressQuery();
  const { t } = useTranslation();
  const component = "subscription-details.shippingCard";

  const address = useMemo(() => {
    if (data == null) return;

    return `${data.address_line1}, ${
      data.address_line2 ? data.address_line2 + " " + "," : ""
    } ${data.city} ${data.state} ${data.zip_code}`;
  }, [data]);

  return (
    <WhiteCard gap={2}>
      <Typography variant="h6" fontWeight={600}>
        {t(`${component}.title`, "Shipping")}
      </Typography>
      {isLoading ? (
        <Typography>
          {t(`${component}.loadingMessage`, "Loading shipping address...")}
        </Typography>
      ) : (
        <Stack gap={1}>
          <Typography variant="subtitle2">
            {t(`${component}.subtitle`, `Shipping Address`)}
          </Typography>
          <Typography>{address}</Typography>
        </Stack>
      )}
    </WhiteCard>
  );
};

export default ShippingCard;
